export const Type = {
  Text: 0,
  Slider: 1,
  Select: 2,
  Combobox: 3,
  Checkbox: 4,
};
